import businessClient from 'src/services/clients/business'
import { IMeta } from 'src/common/interfaces/index.js'

const IShakeHandResponse = { meta: IMeta, data: {} }

export const general = {
  /**
   * @param {{endpoint: string, filter: object, data: object}} payload
   */
  request(payload, signal) {
    return businessClient().post(payload.endpoint, { filter: payload.filter, data: payload.data }, { signal })
  },

  /**
   * @return {Promise<IShakeHandResponse>}
   */
  shakeHand() {
    return businessClient().post('general/shake-hand', {})
  },
}
